module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/communication/spam-f6005d92d0798ebe8c12f49c973ec602.svg";